<script>
export default {
  name: "H2OAnalyticsEntrypoint",
};
</script>

<template>
  <router-view></router-view>
</template>

<style>
@import "../public/shared.css";
@import "../public/layout.css";
@import "../public/calendarstyling.css";
@import "../public/inputs.css";
</style>
